import React, { useEffect, useState, memo } from 'react';
import { HInput, HDatePicker, HTextarea, HRadio, DSelect, HookForm } from '../../../../validation/HForm';
import moment from 'moment';
import { cashBoxService } from '../../../../services/cashbox-service'
import _cloneDeep from 'lodash/cloneDeep';

import './carsForm.scss';
import { translationRuEnSameLetters, createArrayYearsFromNowToPast, permissionsAccess } from '../../../../helpers/common';
import carsFormSchema from "./carsFormSchema";

const defaultFormState = {
  cars: {
    makeOfCar: {value: '', label: ''},
    model: {value: '', label: ''},
    year: {value: '', label: '',},
    carNumber: '',
    quantity: 1,
    marketPrice: '',
    estimatedPrice: '',
    registrationNumber: '',
    registrationDate: '',
    VIN: '',
    condition: '',
    additionalInfo: '',
    garage: null,
  },
};

const years = createArrayYearsFromNowToPast(1970).map((i) => ({ value: i, label: i }));

const CarsForm = memo(({ defaultFormValues, calculationResult = {}, onUpdate, setContextForm, isClear }) => {
  const [cars, setCars] = useState([]);
  const currentModels = cars.find(({ label }) => label === defaultFormValues.makeOfCar.label)?.models
  let form = {};

  useEffect(() => {
    if (defaultFormValues) {
      form.setValue('cars', _cloneDeep(defaultFormValues));
      form.setValue('cars.year', {
        value: defaultFormValues.year.value,
        label: defaultFormValues.year.label,
      })
      form.setValue('cars.model', {
        value: defaultFormValues.model.value,
        label: defaultFormValues.model.label,
      })
      form.setValue('cars.makeOfCar', {
        value: defaultFormValues.makeOfCar.value,
        label: defaultFormValues.makeOfCar.label,
      })
      form.setValue('cars.garage', defaultFormValues.garage || 'Без хранения в ломбарде');
    } else {
      form.setValue('cars', defaultFormState.cars);
    }
  }, [defaultFormValues, form]);

    useEffect(() => {
        if (isClear)
        form.clearErrors()
    }, [isClear])

  useEffect(() => loadCars(), [])

  const loadCars = name => {
    cashBoxService.getCars('')
      .then((response) => {
        setCars(response.data.results.map((v) => ({
                  value: parseInt(v.id),
                  label: v.brand,
                  models: v.model.map((i) => ({
                    value: i,
                    label: i,
                  }))
                })))
      })
  }

  const handleChange = () => {
    const values = form.getValues()
    if (defaultFormValues.makeOfCar.value !== values.cars.makeOfCar.value) {
      values.cars.model = {value: '', label: ''}
      form.setValue('cars.model', {value: '', label: ''})
    }

    if (values.cars.garage !== null) {
        form.clearErrors('cars.garage');
    }

    onUpdate({
      ...values,
      purities: null,
      things: null,
    });
  };

  return (
    <HookForm
      validationSchema={carsFormSchema}
      defaultValues={defaultFormState}
      predef={(methods) => {
          (form = methods)
          setContextForm(methods)
      }}
      mode={'onBlur'}>
      <fieldset className="p-b-0">
        <div className="content-section-title">
          <div className="content-section-title-actionitems nostretch">
            <h2>Залоговая ценность</h2>
          </div>
        </div>
      </fieldset>
      <div className="content-datatable">
        <div className="content-datatable-content">
          <table className="table carForm-table">
            <thead>
              <tr>
                <th scope="col">Марка</th>
                <th scope="col">Модель</th>
                <th scope="col">Год выпуска</th>
                <th scope="col">Количество</th>
                <th scope="col">
                  Оценочная
                  <br />
                  стоимость, руб.
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                    <span className="caption">Марка</span>
                    <div className="select__width">
                        <DSelect
                          h="true"
                          name="cars.makeOfCar"
                          handleChangeContent={handleChange}
                          options={cars}
                          isSearchable={true}
                          isLoading={false}
                        />
                    </div>
                </td>
                <td>
                    <span className="caption">Модель</span>
                      <div className="select__width">
                        <DSelect
                          h="true"
                          name="cars.model"
                          handleChangeContent={handleChange}
                          options={currentModels}
                          isSearchable={true}
                          isLoading={false}
                        />
                      </div>
                </td>
                <td>
                    <span className="caption">Год выпуска</span>
                    <div className="select__width">
                        <DSelect
                          h="true"
                          name="cars.year"
                          options={years}
                          isLoading={false}
                          placeholder="Год выпуска"
                          handleOnChange={handleChange}
                          isSearchable = "true"
                        />
                    </div>
                </td>
                <td>
                    <span className="caption">Количество</span>
                    <div className="form-element-data number">
                        <HInput
                          h="true"
                          className="input__disabled quantity__width"
                          type="number"
                          name="cars.quantity"
                          id="carsQuantity"
                          disabled
                        />
                    </div>
                </td>
                <td>
                    <span className="caption">
                        Оценочная стоимость, руб.
                    </span>
                    <div className="form-element-data number">
                        <HInput
                          h="true"
                          className="input"
                          type="text"
                          name="cars.estimatedPrice"
                          id="carsCost"
                          decimals={2}
                          onBlur={handleChange}
                        />
                    </div>
                </td>
              </tr>
              <tr>
                <th scope="col">VIN номер</th>
                <th scope="col">
                    Номер 
                    <br />
                    гос. регистрации
                </th>
                <th scope="col">
                    Номер
                    <br />
                    свид. регистрации
                </th>
                <th scope="col">
                  Дата выдачи
                  <br />
                  свид. регистрации
                </th>
                <th scope="col">
                  Рыночная
                  <br />
                  стоимость руб.
                </th>
              </tr>
              <tr>
                <td>
                    <span className="caption">VIN номер</span>
                    <div className="form-element limitedWidth">
                        <HInput
                          h="true"
                          className="input-content"
                          type="text"
                          name="cars.VIN"
                          id="VIN"
                          onBlur={handleChange}
                          onChange={(event) => translationRuEnSameLetters(event, form.setValue, "cars.VIN")}
                        />
                    </div>
                </td>
                <td>
                    <span className="caption">Номер гос. регистрации</span>
                    <div className="form-element limitedWidth">
                        <HInput
                          h="true"
                          className="input-content"
                          type="text"
                          name="cars.carNumber"
                          id="carNumber"
                          onBlur={handleChange}
                          onChange={(event) => translationRuEnSameLetters(event, form.setValue, "cars.carNumber")}
                        />
                    </div>
                </td>
                <td>
                    <span className="caption">Номер свид. регистрации</span>
                    <div className="form-element limitedWidth">
                        <HInput
                          h="true"
                          className="input-content text-transform"
                          type="text"
                          name="cars.registrationNumber"
                          id="registrationNumber"
                          onBlur={handleChange}
                        />
                    </div>
                </td>
                <td>
                    <span className="caption">Дата выдачи свид. регистрации</span>
                    <div className="form-element limitedWidth">
                        <HDatePicker
                          h="true"
                          name="cars.registrationDate"
                          onInput={handleChange}
                          className="input-content"
                          id="registrationDate"
                          max={moment().utc().format('YYYY-MM-DD')}
                        />
                    </div>
                </td>
                <td>
                    <span className="caption">
                    Рыночная стоимость руб.
                    </span>
                    <div className="form-element-data number">
                        <HInput
                          h="true"
                          className="input"
                          type="text"
                          name="cars.marketPrice"
                          id="marketPrice"
                          onBlur={handleChange}
                          decimals={2}
                        />
                    </div>
                </td>
              </tr>
              <tr>
                <td colSpan="5">
                  <div className="form-element flex-direction-row m-none">
                    <div className="form-element-data form-element-data__color">
                      <HRadio h
                        labels={['Без хранения в ломбарде', 'C хранением в ломбарде']}
                        name="cars.garage"
                        checkboxStyle
                        onChange = {handleChange}
                        disabled={!permissionsAccess('edit.cashbox.car.storage')}
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th colSpan={2} scope="col">Состояние ТС</th>
                <th colSpan={3} scope="col">Дополнительная информация</th>
              </tr>
              <tr>
                <td colSpan={2}>
                    <HTextarea
                        h="true"
                        className="input full-width"
                        rows="3"
                        name={`cars.condition`}
                        onBlur={handleChange}
                    />
                </td>
                <td colSpan={3}>
                    <HTextarea
                        h="true"
                        className="input full-width"
                        rows="3"
                        name={`cars.additionalInfo`}
                        onBlur={handleChange}
                    />
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="3">
                  <p>Итого</p>
                </td>
                <td colSpan="1">
                  <span className="caption">Количество</span>
                  <p>{calculationResult.totalQuantity}</p>
                </td>
                <td colSpan="2">
                  <span className="caption">
                    Оценочная
                    <br />
                    стоимость, руб.
                  </span>
                  <p>{calculationResult.totalEstimatedValue.toFixed(2)}</p>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </HookForm>
  );
});

export default CarsForm;
